export function TypingIndicator() {
  return (
    <div data-testid="typing-indicator" className="agent-animate-slide-left flex justify-start">
      <img
        src="https://www.chickytutor.com/ui/Chickylogovector.gif?v=0"
        alt="Chicky"
        className="mr-2 mt-1 h-8 w-8 shrink-0 rounded-full border-2 border-black"
      />
      <div className="rounded-2xl rounded-tl-none border-2 border-black bg-[#FFD700] px-5 py-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
        <div className="flex gap-1.5">
          <span className="h-2.5 w-2.5 animate-bounce rounded-full bg-black" />
          <span
            className="h-2.5 w-2.5 animate-bounce rounded-full bg-black"
            style={{ animationDelay: "150ms" }}
          />
          <span
            className="h-2.5 w-2.5 animate-bounce rounded-full bg-black"
            style={{ animationDelay: "300ms" }}
          />
        </div>
      </div>
    </div>
  );
}
